/* eslint-disable global-require */
export default {
    framerate: 2,
    width: 1100,
    height: 720,
    images: [
        require('./SP_NarratorVideo_0.png'),
        require('./SP_NarratorVideo_1.png'),
        require('./SP_NarratorVideo_2.png'),
    ],
    frames: [
        [0, 0, 2048, 1024, 0, 3, 0],
        [0, 1024, 2048, 1024, 0, 3, 0],
        [0, 0, 2048, 1024, 1, 3, 0],
        [0, 1024, 2048, 1024, 1, 3, 0],
        [0, 0, 2048, 1024, 2, 3, 0],
        [0, 1024, 2048, 1024, 2, 3, 0],
    ],
    animations: {
        idleAnimation: { frames: [0], speed: 1 },
        startAnimation: {
            frames: [
                0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0,
            ],
            speed: 1,
        },
    },
};
